import { Component, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { AuthService } from "../_services/auth.service";

@Component({
  selector: "app-session-logout-modal",
  templateUrl: "./session-logout-modal.component.html",
  styleUrls: ["./session-logout-modal.component.scss"],
})
export class SessionLogoutModalComponent implements OnInit {
  constructor(public modal: NgbActiveModal, private authService: AuthService) {}

  ngOnInit(): void {
    setTimeout(() => {
      window.location.reload();
      this.authService.logout();
    }, 30000);
  }
}
